import { API_VERSIONS } from "../utils/constants";
import RequestHandler from "./RequestHandler";

function ClassifierLabelsAPI() {
    const baseClassifierLabelsAPI = "classifier-labels";

    async function createClassifierLabel(payload) {
        try {
            const result = await RequestHandler.post(
                `${API_VERSIONS.v1}/${baseClassifierLabelsAPI}`,
                payload
            );
            return result || {};
        } catch (error) {
            console.log(error);
        }
    }

    async function updateClassifierLabel(payload) {
        try {
            const result = await RequestHandler.put(
                `${API_VERSIONS.v1}/${baseClassifierLabelsAPI}`,
                payload
            );
            return result || {};
        } catch (error) {
            console.log(error);
        }
    }

    async function deleteClassiferLabel(classifierLabelId) {
        try {
            const result = await RequestHandler.remove(
                `${API_VERSIONS.v1}/${baseClassifierLabelsAPI}/${classifierLabelId}`
            );
            return result || {};
        } catch (error) {
            console.log(error);
        }
    }

    return {
        createClassifierLabel,
        updateClassifierLabel,
        deleteClassiferLabel,
    };
}
export default ClassifierLabelsAPI();
